import { render } from "./ConfigServiceScreen.vue?vue&type=template&id=0951e8af"
import script from "./ConfigServiceScreen.vue?vue&type=script&lang=ts"
export * from "./ConfigServiceScreen.vue?vue&type=script&lang=ts"
script.render = render

export default script